export default __webpack_public_path__ + "static/media/360-gradient.5f2b54e1.png";